import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PauseFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("rect", { width: 4, height: 14, x: 6, y: 5, fill: "currentColor", rx: 1 }),
            React.createElement("rect", { width: 4, height: 14, x: 14, y: 5, fill: "currentColor", rx: 1 })));
}
const PauseFill = forwardRef(_PauseFill);
export { PauseFill };
